import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IClientFloors, IClientPlaces, ITables, UserType } from '../../../all-types'
import {
  getFloorList,
  getPlaceList,
  getTableById,
  getTableList,
  getUserList,
  updateCartItemOfTheTable,
} from '../../../services'

const initialState: {
  floors: IClientFloors[]
  places: IClientPlaces[]
  tables: ITables[]
  users: UserType[]
  selectedFloor: IClientFloors | null
} = {
  floors: [],
  places: [],
  tables: [],
  users: [],
  selectedFloor: null,
}

export const PreloadDataSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setFloors: (state, action: PayloadAction<IClientFloors[]>) => {
      state.floors = action.payload
    },
    setSelectedFloor: (state, action) => {
      state.selectedFloor = action.payload
    },
    updateAllTables: (state, action) => {
      state.tables = action.payload
    },
    updateTable:(state, action) => {
      const updatedTable = action.payload;
      if (updatedTable && updatedTable._id && state.tables) {
        state.tables = state.tables.map((item) =>
          item._id === updatedTable._id ? updatedTable : item
        );
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFloorList.fulfilled, (state, action) => {
        state.floors = action.payload
      })
      .addCase(getPlaceList.fulfilled, (state, action) => {
        state.places = action.payload
      })
      .addCase(getTableList.fulfilled, (state, action) => {
        state.tables = action.payload
      })
      .addCase(getTableById.fulfilled, (state, action) => {
        if (state.tables) {
          state.tables = state.tables.map((item) => {
            if (item._id === action.payload._id) {
              return action.payload;
            }
            return item;
          })
        }
      })
      .addCase(updateCartItemOfTheTable.fulfilled, (state, action) => {
        const updatedTable = action.payload;
        if (updatedTable && updatedTable._id && state.tables) {
          state.tables = state.tables.map((item) =>
            item._id === updatedTable._id ? updatedTable : item
          );
        }
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.users = action.payload
      })
  },
})

export const { setFloors, setSelectedFloor, updateTable, updateAllTables } = PreloadDataSlice.actions
